import produce from 'immer';
import { NFT_DISASSEMBLE_LOG_LIST_REQUEST } from '../../constants/log/nftDisassembleLogConstants';

const initialState = {

}

const nftDisassembleLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case NFT_DISASSEMBLE_LOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default nftDisassembleLogReducer;
